
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/[id]",
      function () {
        return require("private-next-pages/galleries/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleries/[id]"])
      });
    }
  